export default "__VITE_ASSET__ab9f812d__"